import React from "react";
import { Button, Container, Form } from "react-bootstrap";
import "./First.css";
import line from "../../../../Asset/d2c/lines.svg";
import { ErrorMessage, Field, Formik } from "formik";
import * as Yup from "yup";
import emailjs from "emailjs-com";

const First = () => {
  const initialValues = {
    firstName: "",
    email: "",
    phoneNumber: "",
  };

  const validationSchema = Yup.object().shape({
    firstName: Yup.string()
      .required("First Name is required")
      .min(2, "First Name must be at least 2 characters"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    phoneNumber: Yup.string()
      .required("Phone Number is required")
      .matches(/^[0-9]{10}$/, "Phone Number must be exactly 10 digits"),
  });

  const sendEmail = (formData, resetForm) => {
    emailjs
      .send(
        process.env.REACT_APP_CONTECT_SERVICE_ID, 
        process.env.REACT_APP_AI_D2C_TEMPLATE_ID, 
        {
          formName: "D2C Form",
          firstName: formData.firstName,
          email: formData.email,
          phoneNumber: formData.phoneNumber,
        },
        process.env.REACT_APP_AI_D2C_PUBLIC_ID 
      )
      .then(
        (result) => {
          alert("Your info is sent successfully!");
          resetForm();
        },
        (error) => {
          console.error("Failed to send email:", error.text);
          alert("Failed to send your info.");
        }
      );
  };
  return (
    <>
      <section className="first-d2c-section">
        <Container>
          <div className="row d2c-first-row">
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 shopify-hero-col-1">
              <div className="hero-title">
                <div className="hero-dec-text">
                  <h1 className="h1">
                    Personalized <strong> D2C </strong> eCommerce Solution{" "}
                  </h1>
                  <div className="dec-text">
                    <p>
                      Scale your business with a powerful online presence and
                      exceptional customer experiences.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 shopify-hero-col-2">
              <div className="d2c_form_part">
                <div className="form_wrap">
                  <div className="d2c-form-title">
                    <p className="indu-form-title">
                      Accelerate your <strong> D2C </strong> Growth
                    </p>
                  </div>
                  <div className="main-form">
                    <Formik
                      initialValues={initialValues}
                      validationSchema={validationSchema}
                      onSubmit={(values, { resetForm }) => {
                        sendEmail(values, resetForm);
                      }}
                    >
                      {({ errors, touched, handleSubmit }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                          <div className="row">
                            <div className="col-md-12">
                              <div className="form-group">
                                <Form.Floating>
                                  <Field
                                    as={Form.Control}
                                    id="inputCustom"
                                    name="firstName"
                                    placeholder="Name*"
                                    isInvalid={
                                      touched.firstName && errors.firstName
                                    }
                                  />
                                  <label htmlFor="firstName">Name*</label>
                                  <ErrorMessage
                                    name="firstName"
                                    component="div"
                                    className="text-danger"
                                  />
                                </Form.Floating>
                              </div>
                            </div>
                          </div>
                          <div className="col-xl-12 col-lg-12 col-md-12 d2c-cnt-number">
                            {" "}
                            <div className="form-group">
                              <Form.Floating>
                                <Field
                                  as={Form.Control}
                                  id="inputCustom"
                                  name="phoneNumber"
                                  placeholder="Phone Number*"
                                  isInvalid={
                                    touched.phoneNumber && errors.phoneNumber
                                  }
                                />
                                <label htmlFor="phoneNumber">
                                  Phone Number*
                                </label>
                                <ErrorMessage
                                  name="phoneNumber"
                                  component="div"
                                  className="text-danger"
                                />
                              </Form.Floating>
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="form-group">
                              <Form.Floating>
                                <Field
                                  as={Form.Control}
                                  id="inputCustom"
                                  name="email"
                                  placeholder="Email*"
                                  isInvalid={touched.email && errors.email}
                                />
                                <label htmlFor="email">Email*</label>
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="text-danger"
                                />
                              </Form.Floating>
                            </div>
                          </div>
                          <Button type="submit" className="submit-btn">
                            Contact Us
                          </Button>
                        </Form>
                      )}
                    </Formik>
                  </div>
                  <div className="floating-img">
                    <img alt="floating" src={line} className="w-100" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default First;
